import { create } from 'zustand';

const useStore = create((set) => ({
  products: null,
  setProducts: (newProduct) =>
    set((state) => {
      const existingProducts = JSON.parse(localStorage.getItem('products')) || {};
      const updated = {
        ...(existingProducts || {}),
        ...newProduct,
      };

      // Save to localStorage
      localStorage.setItem('products', JSON.stringify(updated));

      return { products: updated };
    }),
  removeProduct: (productId) =>
    set((state) => {
      const existingProducts = JSON.parse(localStorage.getItem('products')) || {};
      const updatedProducts = Object.fromEntries(
        Object.entries(existingProducts).filter(([id]) => id !== productId)
      );

      // Save to localStorage
      localStorage.setItem('products', JSON.stringify(updatedProducts));

      return { products: updatedProducts };
    }),
}));

export default useStore;